// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AitL","title":"styles_title__2AyVa"};